import React from 'react';
import { Drawer } from '../ui/overlay';
import PlacementsTable from './PlacementsTable';

/** Drawer listing the placements behind a number the user clicked. */
export default function Drilldown({ title, org, lead, filters, showProjected, onClose }) {
  return (
    <Drawer wide title={title} onClose={onClose}>
      <div className="card flush" style={{ margin: -24 }}>
        <PlacementsTable fixed={{ organization: org, lead }} initialFilters={filters} showProjected={showProjected} initialSize={10} />
      </div>
    </Drawer>
  );
}
